import React from 'react';
import { useTranslation } from 'react-i18next';
import FeedbackToast from '../../common/components/FeedbackToast';

const ShareTestBetaFeatureToast: React.FC = () => {
  const { t } = useTranslation();

  return (
    <FeedbackToast
      text={t('Share your feedback to improve the experience!')}
      surveyLink={'https://www.surveymonkey.com/r/B8GK9C8'}
    />
  );
};

export default ShareTestBetaFeatureToast;
